import Button from "../../lms/ButtonComponent";
import { BUTTON_VARIANTS } from "../../lms/constant";
import { useGetTranslatedText } from "../../lms/queries";

import styles from "./styles.module.scss";

const SubmitModal = ({ onClose, onSubmit,loader }) => {
  const languageId = localStorage.getItem("l_id") || 1;
        
  const { data: translatedTextResponse } = useGetTranslatedText(languageId);
        
  const { data: translatedText = [] } = translatedTextResponse || {};

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        {/* Icon */}
        <div className={styles.iconWrapper}>
          <div className={styles.checkIcon}>✓</div>
        </div>

        {/* Content */}
        <h2 className={styles.title}>Ready to Submit?</h2>
        <p className={styles.subtitle}>
          You have successfully answered all 10 questions.
        </p>

        {/* Actions */}
        <div className={styles.actions}>
          <Button className={styles.reviewBtn} buttonVariant={BUTTON_VARIANTS.TERNARY}  label='Review Again' onClick={onClose} />
          <Button className={styles.submitBtn} disabled={loader}  label={loader ? 'loading...' :'Submit'} onClick={onSubmit} />
        </div>
      </div>
    </div>
  );
};

export default SubmitModal;